import style from "./Update.module.scss";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import { nervePostSchema } from "../../components/validation/Schema";
import { addHospitalCohortAll } from "../../redux/admin/actions/admin.actions";
import { SelectField } from "../../components/Form/SelectField";
import { loadHospitals } from "../../redux/admin/actions/admin.actions";
import { useParams } from "react-router-dom";
import axiosClient from "../../service/axios";
import { agentAddedSuccessToast } from "../../components/NotificationToast";

const CreateForm = ({ setCreateModal, handleSuccessPost }) => {
  const [prem, setPrem] = useState([]);
  const { id } = useParams();
  const { hospitals } = useSelector((state) => state.adminReducer);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  // };

  useEffect(() => {
    dispatch(loadHospitals());
    const option = hospitals?.map((p) => ({
      label: p.name,
      value: p.ref_id,
    }));
    setPrem(option);
  }, [dispatch]);

  return (
    <Formik
      initialValues={{
        ref_id: "",
      }}
      // validationSchema={nervePostSchema}
      onSubmit={(values, actions) => {
       
        try {
          setLoading(true);
          // axiosClient.post(`/lite/v2/api/admin/hospital/cohort/add/hospital`, {
          //   cohort: id,
          //   hospitals: [{ id: values.ref_id.value }],
          // });

          axiosClient.post(`/lite/v2/api/admin/hospital/cohort/add/hospital`, {
            cohort: id,
            hospitals: [{ id: values.ref_id.value }],
          });

          // dispatch(
          //   addHospitalCohortAll({
          //     cohort: id,
          //     hospitals: [{ id: values.ref_id.value }],
          //   })
          // );

          actions.resetForm({
            hospital: "",
          });
          handleSuccessPost();
          agentAddedSuccessToast();

          setCreateModal(false);
          setLoading(false);
        } catch (error) {
          console.log("eeor", error);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        handleBlur,
      }) => (
        <Form onSubmit={handleSubmit}>
          <h3 className="text-center" style={{color: "#B70303", fontWeight: "bold"}}>Add Hospital</h3>
          <div className="form-group">
            <label htmlFor="hospitalName">Hospital Name</label>

            <SelectField
              name="ref_id"
              placeholder={"select hospital"}
              options={prem}
              // required
            />
          </div>

          <div className={style.buttonContainer}>
            <button
              type="submit"
              className={`shadow-none  ${style.actionBtn} ${style.reject}`}
              // disabled={loading}
            >
              Submit
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CreateForm;
